import React from "react";
import QRCodeGenerator from "./QRCodeGenerator";
import CopyLink from "./CopyLink";
import AppButton from "components/ui/AppButton.jsx";
import { useTranslation } from "react-i18next";
function PickupDelivery({
  settings,
  orderPageLink,
  qrCodeSetting,
  handleDownload,
}) {
  const { t } = useTranslation();
  return (
    <div className=" py-2 w-full lg:w-1/2">
      <QRCodeGenerator
        id="pickup"
        orderPageLink={orderPageLink}
        settings={settings}
        qrCodeSetting={qrCodeSetting}
      />
      <div className="flex flex-col md:flex-row gap-3 ml-2">
        <CopyLink {...{ orderPageLink }} />
        <AppButton type="button" onClick={() => handleDownload("pickup")}>
          {t("Download QR code")}
        </AppButton>
      </div>
    </div>
  );
}

export default PickupDelivery;
